Adcurve.humanize = function (str) {
  str = str.replace(/_/g, ' ');
  return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
};
Adcurve.titleCase = function (str) {
  return Lazy(str.split(' ')).map(Adcurve.humanize).toArray().join(' ')
};
